import React from "react";
import { Link } from "react-router-dom";
import { Clock3, Bug, MessageSquareHeart, ChevronRight } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const APP_VERSION = "1.0.0";
const SUPPORT_EMAIL = "support@heldall.com";
const FEEDBACK_EMAIL = "feedback@heldall.com";

function mailto(to, subject, intro) {
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";
  const url = typeof window !== "undefined" ? window.location.href : "";
  const body =
    `${intro}\n\n\n— — — — — — — — — —\n(The details below help us help you. Feel free to leave them.)\n` +
    `App: Heldall v${APP_VERSION}\nPage: ${url}\nDevice/Browser: ${ua}`;
  return `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

export function SettingsLinksCard() {
  const { user } = useAuth();
  const acct = user?.email ? `\nAccount: ${user.email}` : "";

  return (
    <div className="rounded-2xl bg-[var(--surface)] border border-[var(--line)] shadow-[0_2px_8px_rgba(0,0,0,0.04)] overflow-hidden mb-6"
      data-testid="settings-links-card">
      <Link
        to="/timeline"
        data-testid="settings-activity-link"
        className="flex items-center gap-3 px-6 md:px-8 py-4 hover:bg-[var(--surface3)] transition-colors duration-200 border-b border-[var(--line2)]"
      >
        <span className="h-9 w-9 rounded-full bg-[var(--line2)] flex items-center justify-center text-[var(--ink2)] shrink-0">
          <Clock3 size={17} strokeWidth={1.9} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-[15px] font-semibold text-[var(--ink)]">Activity</span>
          <span className="block text-[13px] text-[var(--ink3)]">Your history: what you captured and when things resurfaced.</span>
        </span>
        <ChevronRight size={18} className="text-[var(--ink5)] shrink-0" />
      </Link>

      <p className="px-6 md:px-8 pt-4 pb-1 text-[13px] text-[var(--ink3)] leading-relaxed" data-testid="feedback-reassurance">
        Send us anything that feels off. A real person reads it and replies.
      </p>

      <a
        href={mailto(SUPPORT_EMAIL, "Heldall — Report an issue", `Something isn’t working as expected:${acct}`)}
        data-testid="settings-report-issue"
        className="flex items-center gap-3 px-6 md:px-8 py-4 hover:bg-[var(--surface3)] transition-colors duration-200 border-b border-[var(--line2)]"
      >
        <span className="h-9 w-9 rounded-full bg-[var(--line2)] flex items-center justify-center text-[var(--ink2)] shrink-0">
          <Bug size={17} strokeWidth={1.9} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-[15px] font-semibold text-[var(--ink)]">Report an issue</span>
          <span className="block text-[13px] text-[var(--ink3)]">Tell us what went wrong and we’ll look into it.</span>
        </span>
        <ChevronRight size={18} className="text-[var(--ink5)] shrink-0" />
      </a>

      <a
        href={mailto(FEEDBACK_EMAIL, "Heldall — Feedback", `Here’s some feedback on Heldall:${acct}`)}
        data-testid="settings-share-feedback"
        className="flex items-center gap-3 px-6 md:px-8 py-4 hover:bg-[var(--surface3)] transition-colors duration-200"
      >
        <span className="h-9 w-9 rounded-full bg-[var(--line2)] flex items-center justify-center text-[var(--ink2)] shrink-0">
          <MessageSquareHeart size={17} strokeWidth={1.9} />
        </span>
        <span className="min-w-0 flex-1">
          <span className="block text-[15px] font-semibold text-[var(--ink)]">Share feedback</span>
          <span className="block text-[13px] text-[var(--ink3)]">Ideas, wishes, what you love. We read everything.</span>
        </span>
        <ChevronRight size={18} className="text-[var(--ink5)] shrink-0" />
      </a>
    </div>
  );
}

export default SettingsLinksCard;
